import { render } from "./EmailTemplateEditFormComponent.vue?vue&type=template&id=372e7df8"
import script from "./EmailTemplateEditFormComponent.vue?vue&type=script&lang=js"
export * from "./EmailTemplateEditFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__